import { ArgumentError } from '../utils/errors';

import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class BookingModel extends BaseAPIModel {
    /*     static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][AttendeeModel][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/inventories`;
    } */

    get isGA() {
        return !this.object.seat_uuid && this.object.area_zone;
    }

    get seat() {
        return this.object.seat_seat;
    }

    get row() {
        return this.object.seat_row;
    }

    get access() {
        return this.object.seat_access;
    }

    get zone() {
        return this.object.seat_zone;
    }

    get zoneName() {
        return this.object.seat_zone_name;
    }

    get category() {
        return this.object.seat_category;
    }
}

export class Booking extends BookingModel {
    fields() {
        return {
            booking_uuid: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, inventoryId, zoneId, chartId }) {
        if (!inventoryId || !zoneId || !chartId) {
            throw new ArgumentError(`[Model][Booking] organizationId, eventId, chartId, inventoryId and zoneId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/api/charts/${chartId}/inventories/${inventoryId}/zones/${zoneId}/bookings`;
    }

    unbook({ organizationId, bookings, chartId }) {
        if (!chartId || !organizationId) {
            throw new ArgumentError(`[Model][Booking] chartId is mandatory to unbook`);
        }
        return fetcher.delete(`/ticket/organizations/${organizationId}/api/charts/${chartId}/bookings/unbook`, { data: bookings });
    }
}
